/*
 * @Author: zfd
 * @Date: 2020-09-06 10:08:57
 * @LastEditTime: 2020-09-06 18:57:28
 * @Description: 
 * @FilePath: \trip-enterprise\src\common\auth.js
 */
import VueCookies from 'vue-cookies'

const TokenKey = 'trip-token', UserId = 'sessionId';
//设置cookie参数
// default: expireTimes = 1d, path = '/', domain = '', secure = '', sameSite = 'Lax'
VueCookies.config('30d');

/**
 * 获取Cookie
 * @param {*} keyName 
 */
export function getCookie(keyName) {
    return VueCookies.get(keyName)//不存在返回null
}

/**
 * 设置Cookie
 * @param {*} keyName 
 * @param {*} value 
 * @param {*} expire 
 */
export function setCookie(keyName, value, expire) {
    //console.log(Cookies.get(TokenKey))
    if (expire) {
        let expireTime = new Date(expire);
        return VueCookies.set(keyName, value, { expires: expireTime })
    }
    return VueCookies.set(keyName, value)
}

/**
 * 删除Cookie
 * @param {*} keyName 
 */
export function removeCookie(keyName) {
    return VueCookies.remove(keyName)
}

/**
 * 获取token并更新token(包括sessionId)
 */
export function getToken() {
    let token = VueCookies.get(TokenKey);
    if (token) {
        const time = Number(token.slice(0, 4) + token.slice(-9));
        const expires = Number(token.slice(-13, -9) + token.substr(4, 3))
        if (isNaN(time) || isNaN(expires)) {
            return null;
        }
        //到期时间  19分58秒
        const endTime = time + parseInt(expires / 1000 / 100) * 60 * 1000 + expires % 100 * 1000;
        //10分钟刷新一次
        if (new Date(endTime) - 10 * 60 * 1000 <= new Date()) {
            //即将过期
            token = updateToken(token)
        }
    }
    return token;
}

/**
 * 更新token(包括sessionId)
 * @param {*} token 
 * @param {*} expire 
 */

function updateToken(token) {
    if (!token) {
        return ''
    }
    const body = token.slice(7, -13);
    const now = new Date().getTime().toString();
    const newToken = now.slice(0, 4).concat(token.substr(4, 3), body, token.slice(-13, -9), now.substr(4));
    const loginInfo = {
        token: newToken,
        userId: VueCookies.get(UserId)
    }
    setToken(loginInfo)
    return newToken;
}
/**
 * 设置token(包括seesionId)
 * @param {*} token 
 * @param {*} expire 
 */
export function setToken(loginInfo) {
    if (!loginInfo) {
        return false
    }
    const token = loginInfo.token;
    // const time = Number(token.slice(0, 4) + token.slice(-9));
    const expires = Number(token.slice(-13, -9) + token.substr(4, 3))
    if (isNaN(expires)) {
        return false;
    }
    const userId = loginInfo.userId;
    //19分58秒后过期  19*58*1000
    let _expires = `${parseInt(expires / 1000 / 100)}min`;
    VueCookies.set(UserId, userId, _expires);
    VueCookies.set(TokenKey, token, _expires)
    return true
}

/**
 * 删除token
 */
export function removeToken() {
    VueCookies.remove(TokenKey)
    VueCookies.remove(UserId)
}

/**
 * 判断是否在登录状态
 */
export function hasLogined() {
    const token = VueCookies.get(TokenKey);
    if (token === null) {
        return false;
    }
    return true;
}

/**
 * 返回头信息
 */
export function getVoucher() {
    const voucher = {
        token: VueCookies.get(TokenKey),
        sessionId: VueCookies.get(UserId)
    }
    return voucher
}